import Dashboard from "@/pages/Dashboard";

interface AppPageProps {
  initialSection?: string;
}

const AppPage = ({ initialSection }: AppPageProps) => {
  return <Dashboard initialSection={initialSection} />;
};

export default AppPage;

